import { HeaderWrapper } from 'layouts';
import { type GivingContentObjectDetail, GivingTypeEnum } from 'models';
import { Col, HandHeartLineIcon, HeaderAsset, HeaderContent, Row } from 'ui';
import { images } from 'common/utils';
import { BookmarkButton } from 'features/bookmark';
import { LikeButton } from 'features/like';
import { GiversCount } from '../components';
import { useGivingTypeOptions } from '../hooks';
import { useActions } from './hooks';

type P = { givingContentObject: GivingContentObjectDetail };

const GivingHeader = ({ givingContentObject }: P) => {
  const { coverPhoto, endTime, name, startTime } = givingContentObject.giving;
  const { getTranslate } = useGivingTypeOptions();
  const { giving } = givingContentObject;

  const { actions } = useActions({ givingContentObject });

  const isParticipantsVisible = giving.type === GivingTypeEnum.CROWDFUNDING || giving.type === GivingTypeEnum.DONATION;

  return (
    <HeaderWrapper
      left={
        <HeaderAsset image={{ alt: 'Giving cover photo', src: coverPhoto?.url ?? images.default.givingCoverPhoto }} />
      }
      right={
        <HeaderContent
          actions={actions}
          extra={
            <Row align="middle" gutter="xs">
              <Col>
                <LikeButton contentObject={givingContentObject} />
              </Col>
              <Col>
                <BookmarkButton contentObject={givingContentObject} />
              </Col>
            </Row>
          }
          tags={{
            children: getTranslate(giving.type),
            color: 'orange',
            icon: <HandHeartLineIcon />,
          }}
          timeInfo={endTime ? { dateFrom: startTime, dateTo: endTime } : undefined}
          title={name}
        >
          {isParticipantsVisible ? <GiversCount count={giving.giversCount} /> : null}
        </HeaderContent>
      }
    />
  );
};

export default GivingHeader;
